import React from "react";
import {
  FooterContainer,
  FooterWrap,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  SocialIconLink,
  AnchorLink,
} from "./FooterStyles";
import {
  FaFacebook,
  FaGithub,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaLink,
} from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";
import { AiOutlineHeart } from "react-icons/ai";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";

function Footer() {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <FooterContainer>
      <FooterWrap>
        <Slide bottom>
          <FooterLinksContainer>
            <FooterLinksWrapper>
              <FooterLinkItems>
                <FooterLinkTitle>About Us</FooterLinkTitle>
                <FooterLink to="/">How It Works</FooterLink>
                <FooterLink to="/sigin">Testimonials</FooterLink>
                <FooterLink to="/sigin">Terms of service</FooterLink>
                <FooterLink to="/sigin">Investors</FooterLink>
                <FooterLink to="/sigin">Careers</FooterLink>
              </FooterLinkItems>
              <FooterLinkItems>
                <FooterLinkTitle>Videos</FooterLinkTitle>
                <FooterLink to="/">Submit video</FooterLink>
                <FooterLink to="/sigin">Agency</FooterLink>
                <FooterLink to="/sigin">Influencer</FooterLink>
              </FooterLinkItems>
            </FooterLinksWrapper>

            <FooterLinksWrapper>
              <FooterLinkItems>
                <FooterLinkTitle>Contact Us</FooterLinkTitle>
                <FooterLink to="/">Contact</FooterLink>
                <FooterLink to="/sigin">Support</FooterLink>
                <FooterLink to="/sigin">Destination</FooterLink>
                <FooterLink to="/sigin">Sponsorship</FooterLink>
              </FooterLinkItems>
              <FooterLinkItems>
                <FooterLinkTitle>Social Media</FooterLinkTitle>
                <FooterLink to="/">Facebook</FooterLink>
                <FooterLink to="/sigin">Instagram</FooterLink>
                <FooterLink to="/sigin">Twitter</FooterLink>
                <FooterLink to="/sigin">Youtube</FooterLink>
              </FooterLinkItems>
            </FooterLinksWrapper>
          </FooterLinksContainer>
        </Slide>
        <SocialMedia>
          <Fade bottom>
            <SocialMediaWrap>
              <SocialLogo to="/" onClick={toggleHome}>
                Fitness Zone
              </SocialLogo>
              <WebsiteRights>
                Fitness zone &copy; {new Date().getFullYear()} All rights
                resolved. <br /> Created with <AiOutlineHeart /> by{" "}
                <span>
                  {" "}
                  <AnchorLink
                    target="_blank"
                    href="https://nobertdev-portfolio.netlify.app"
                  >
                    {" "}
                    Nobert.Dev{" "}
                  </AnchorLink>{" "}
                </span>
              </WebsiteRights>
              <SocialIcons>
                <SocialIconLink
                  href="https://www.facebook.com/nobert.langat.12"
                  target="_blank"
                  aria-label="Facebook"
                >
                  <FaFacebook />
                </SocialIconLink>
                <SocialIconLink
                  href="https://github.com/NOBERT167"
                  target="_blank"
                  aria-label="Github"
                >
                  <FaGithub />
                </SocialIconLink>
                <SocialIconLink
                  href="https://twitter.com/Darkcode1999"
                  target="_blank"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                </SocialIconLink>
                <SocialIconLink
                  href="https://www.linkedin.com/mwlite/in/langat-kipkoech-nobert-ab44661ba"
                  target="_blank"
                  aria-label="Linkedin"
                >
                  <FaLinkedinIn />
                </SocialIconLink>
                <SocialIconLink
                  href="https://www.instagram.com/nobert.dev/"
                  target="_blank"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </SocialIconLink>
                <SocialIconLink
                  href="https://bio.link/nobertdev"
                  target="_blank"
                  aria-label="Biolink"
                >
                  <FaLink />
                </SocialIconLink>
              </SocialIcons>
            </SocialMediaWrap>
          </Fade>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
}

export default Footer;
